module.exports = __webpack_public_path__ + "img/pc@2x.77be8c01.png";